/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpRespSidebarSellerInfo_viewer$ref: FragmentReference;
export type PdpRespSidebarSellerInfo_viewer = {|
  +isReviewsEnabled: ?boolean,
  +isNewSellerPillEnabled: ?boolean,
  +$refType: PdpRespSidebarSellerInfo_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpRespSidebarSellerInfo_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": "isReviewsEnabled",
      "name": "isEnabledByLocale",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "ORDER_FEEDBACK",
          "type": "String!"
        }
      ],
      "storageKey": "isEnabledByLocale(featureName:\"ORDER_FEEDBACK\")"
    },
    {
      "kind": "ScalarField",
      "alias": "isNewSellerPillEnabled",
      "name": "isEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "key",
          "value": "enableNewSellerPill",
          "type": "String!"
        }
      ],
      "storageKey": "isEnabled(key:\"enableNewSellerPill\")"
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '342b18fbb45362c28bfceff8ffc97a84';
module.exports = node;
